import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.994 2A5.997 5.997 0 0 0 2 8c0 3.312 2.682 6 5.994 6A6.003 6.003 0 0 0 14 8c0-3.312-2.688-6-6.006-6m4.158 3.6h-1.77a9.4 9.4 0 0 0-.828-2.136A4.82 4.82 0 0 1 12.152 5.6M8 3.224c.498.72.888 1.518 1.146 2.376H6.854A8.5 8.5 0 0 1 8 3.224M3.356 9.2A5 5 0 0 1 3.2 8c0-.414.06-.816.156-1.2h2.028A10 10 0 0 0 5.3 8c0 .408.036.804.084 1.2zm.492 1.2h1.77c.192.75.468 1.47.828 2.136A4.8 4.8 0 0 1 3.848 10.4m1.77-4.8h-1.77a4.8 4.8 0 0 1 2.598-2.136A9.4 9.4 0 0 0 5.618 5.6M8 12.776A8.5 8.5 0 0 1 6.854 10.4h2.292A8.5 8.5 0 0 1 8 12.776M9.404 9.2H6.596A9 9 0 0 1 6.5 8c0-.408.042-.81.096-1.2h2.808c.054.39.096.792.096 1.2s-.042.804-.096 1.2m.15 3.336a9.4 9.4 0 0 0 .828-2.136h1.77a4.82 4.82 0 0 1-2.598 2.136M10.616 9.2A10 10 0 0 0 10.7 8a10 10 0 0 0-.084-1.2h2.028c.096.384.156.786.156 1.2s-.06.816-.156 1.2z"
    }, null, -1)
  ])))
}
export default { render: render }